import {Component} from '@angular/core';

@Component({
  selector: 'app-case-payments-step',
  templateUrl: './case-payments-step.component.html',
})
export class CasePaymentsStepComponent {
  constructor() {
  }
}
